var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 22 21",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.1514 1.36091c.3915-.627872 1.3057-.627872 1.6972 0l2.8265 4.53312c.137.21975.3539.37778.6051.44082l5.1745 1.29862c.7152.17948.9968 1.04481.5242 1.61081l-3.4292 4.10752c-.1654.198-.2478.4523-.23.7097l.3686 5.3426c.0508.7371-.6879 1.273-1.3728.9957l-4.9403-1.9994c-.2407-.0974-.5097-.0974-.7504 0l-4.94028 1.9994c-.68496.2773-1.42365-.2586-1.37279-.9957l.3686-5.3426c.01775-.2574-.06465-.5117-.22999-.7097l-3.42928-4.10752c-.472546-.566-.190934-1.43133.52422-1.61081l5.1745-1.29862c.25119-.06304.46812-.22107.60514-.44082z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/star-icon.753de33a1ab0219652ac021aefb892b0.svg";